const FromArr = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	modelvalue: "",
	title: "平台/经销商：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 40,
	marginTop: -5,
	displayVal: "inline-block",
	fontWeightVal: 500
}]

export {
	FromArr
}